module.exports = __webpack_public_path__ + "assets/img/17_1022.20ce533f.jpg";